import React from "react";
import DashboardPage from "../components/Dashboard/page/DashboardPage"

const Dashboard = () => <DashboardPage />;

export default Dashboard;